export const HOME_DISCLOSURES_STRINGS = {
  title:
    'Anything important we need to tell future <span>renters about?</span>',
  subtitle:
    'Select all legally required disclosures that you know about at <strong>{address}</strong>.',
  describe: 'Additional Information',
  permitted_bedrooms: '# of permitted bedrooms',
  'disclosures_documentation.title':
    "We've prepared your <span>disclosures form.</span>",
  'disclosures_documentation.subtitle':
    "As required by law or regulation, we'll include this in your future <span>Residents' lease.</span>",
  done_label: 'Done',
  'done_label.units': 'Next Unit',
  view_form: 'View Form',
  checkbox_label: 'I agree to electronically sign this\u00a0form.',
  known_radon_concentration: 'Are there known radon concentrations?',
  bed_bugs_treated: 'Was it treated?',
  building_bed_bugs_floors_where_it_occurred: 'Floors Where It Occurrred',
  last_serviced_on: 'When was it last serviced? (MM/DD/YYYY)',
  constructed_before_1960: 'Was it constructed before January 1, 1960?',
  date_of_last_radon_test: 'Last Radon Test (MM/DD/YYYY)',
  gallons_in_tank: 'Gallons in tank',
  noise_zone: 'Noise Zone',
  accident_potential_zone: 'Accident Potential Zone (APZ)',
  less_than_65_decibels: 'Under 65 dB',
  between_65_and_70_decibels: '65-70 dB',
  between_70_and_75_decibels: '70-75 dB',
  more_than_75_decibels: 'Over 75 dB',
  none: 'None',
  apz_1: 'APZ-1',
  apz_2: 'APZ-2',
  clear_zone: 'Clear Zone',
  was_the_detected_radon_in_excess_of_4_0_pCi_L:
    'Was the detected radon in excess of 4.0 pCi/L?',
  was_it_remedied: 'Was it remedied?',

  // ---- Washington DC: Housing-code violations (HOM-244) ----
  'housing_code.notices_last_12_months': 'Notices issued (past 12 months)',
  'housing_code.unabated_count': 'Currently unabated',
  'housing_code.date': 'Date (MM/DD/YYYY)',
  'housing_code.code_section': 'Condition / code section',
  'housing_code.location': 'Location',
  'housing_code.file_label': 'Notice',
  'housing_code.add_row': 'Add another violation',

  // ---- Washington DC: Condo / co-op association ----
  'condo_coop.condominium': 'Part of a condominium',
  'condo_coop.cooperative': 'Part of a cooperative housing association',
  'condo_coop.cooperative_sublabel':
    'Requires an association letter authorizing rental of the unit',
  'condo_coop.converting': 'Converting',
  'condo_coop.converting_sublabel':
    'To condominium, cooperative housing, or non-housing use',

  // ---- Washington DC: Indoor mold contamination ----
  'indoor_mold.description': 'Describe the contamination and its status.',

  // ---- Washington DC: Rent surcharge / pending petition ----
  'rent_surcharge.amount': 'Monthly surcharge ($)',
  'rent_surcharge.expiration': 'Surcharge expiration (MM/DD/YYYY)',
  'rent_surcharge.comment': 'Additional details',

  // ---- Washington DC: Rent increase method ----
  'rent_increase.once_per_12_months': 'No more than once every 12 months',
  'rent_increase.once_per_12_months_sublabel':
    'Default for rent-stabilized units',
  'rent_increase.per_covenant': 'Per covenant / subsidy / HCV contract',
  'rent_increase.per_covenant_sublabel':
    'Affordability covenant, long-term subsidy, or housing choice voucher contract',
};
